import styled from 'styled-components';

export const WorkBox = styled.div`
    margin-bottom: ${props => props.num != 3 ? "35px" : 0}
`